/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CasesToBranchAssignRequest } from '../../models/cases-to-branch-assign-request';
import { Tour } from '../../models/tour';

export interface AssociateCaseWithBranch$Params {
      body: CasesToBranchAssignRequest
}

export function associateCaseWithBranch(http: HttpClient, rootUrl: string, params: AssociateCaseWithBranch$Params, context?: HttpContext): Observable<StrictHttpResponse<Tour>> {
  const rb = new RequestBuilder(rootUrl, associateCaseWithBranch.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tour>;
    })
  );
}

associateCaseWithBranch.PATH = '/api/v1/branches/associated_cases';
